<template>
  <v-dialog
    v-model="open"
    width="900"
  >
    <v-card>
      <v-card-title
        class="headline orange lighten-1"
        primary-title
      >
        <v-row no-gutters>
          <v-col>Changes found</v-col>
<!--          <v-col class="justify-end">-->
<!--            <v-switch class="mt-0 float-right" v-model="toggle" :hide-details=true label="Changes Only" @change="showUnchanged"></v-switch>-->
<!--          </v-col>-->
        </v-row>
      </v-card-title>

      <v-card-text class="card-text-height">
        <v-card-subtitle class="px-0 grey--text">
          Dates being compared: {{formatDate(left.scrapedDate)}} - {{formatDate(right.scrapedDate)}}
        </v-card-subtitle>

        <div>
          <v-row v-if="totalChanges">
            <v-col cols="12">
              There are {{totalChanges}} items that changed:
            </v-col>
            <v-col cols="12">
              <v-expansion-panels
                multiple
                focusable
              >
                <v-expansion-panel v-for="(item, key) in delta" v-bind:key="key">
                  <v-expansion-panel-header>{{key}} - {{getNumberOfChangesInSection(item)}} items changed</v-expansion-panel-header>
                  <v-expansion-panel-content v-html="subPartFormatted(item)" class="custom-content-diff">

                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              There are no significant changes in the profile
            </v-col>
          </v-row>

        </div>

<!--        <div id="formatted-diff" v-html="formatted">-->
<!--        </div>-->
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions fixed>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dismiss()">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {formatters} from "jsondiffpatch";
  import {getNumberOfChangesInSection} from "../../../helpers/helpers";

  export default {
    name: "profileChanges",
    props: ['delta', 'left', 'right', 'totalChanges'],
    data() {
      return {
        toggle: true,
        open: false,
        formatted: null
      }
    },
    methods: {
      openModal(){
        this.open = true;
        this.showDiffs();
      },
      showDiffs() {
        this.formatted = formatters.html.format(this.delta, this.left);
        formatters.html.hideUnchanged();
      },
      subPartFormatted(item) {
        return formatters.html.format(item, this.left);
      },
      hideUnchanged() {
        formatters.html.hideUnchanged();
      },
      showUnchanged() {
        formatters.html.showUnchanged(!this.toggle);
      },
      getNumberOfChangesInSection(item){
        return getNumberOfChangesInSection(item);
      },
      dismiss() {
        this.open = false;
        // this.$ga.event('Staff', 'cancel', 'profile changes modal');
        this.$gtag.event('cancel', {
          event_category: 'Staff',
          event_label: 'profile changes modal'
        });
      },
      formatDate(date) {
        return (new Date(date)).toLocaleDateString();
      }
    }
  }
</script>

<style scoped>
  .card-text-height {
    max-height: 350px;
    overflow-y: scroll
  }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Profiles/profileChanges.vue